import { styled } from '@mui/material/styles';

export const FlexSpacer= styled('div')({flexBasis: 'auto', flexGrow: 1, flexShrink: 1});